import { createFileRoute } from '@tanstack/react-router'
import { AgentSkillsPage } from '../../../modules/agent-workspace'

export const Route = createFileRoute('/_authed/agent-workspace/skills')({
  component: AgentSkillsPage,
})
